import React from "react";
import manateeLogo from "../../assets/screener/manatee-logo.png";

export default function ScreenerHeader() {
  return (
    <header className="screener-header" aria-label="Manatee for pediatric practices">
      <img className="screener-header__logo" src={manateeLogo} alt="Manatee" />
      <span className="screener-header__divider" aria-hidden="true" />
      <span className="screener-header__tagline">For pediatric practices</span>
    </header>
  );
}
